const app = {
  theme: {
    primary: {
      color: 'orange',
      hue: 800,
      textColor: 'white',
    },
    accent: 'brown',
    warn: {
      color: 'red',
      hue: 400,
    },
    background: 'white',
  },
  title: 'Tradelinks',
};

export const themeVuetify = {
  primary: '#EF6C00',
  secondary: '#b0bec5',
  tertiary: '#8bc34a',
  accent: '#795548',
  error: '#b71c1c',
  warning: '#EF5350',
};

export default (Vue) => {
  Vue.material.registerTheme('default', app.theme);
};
export const title = app.title;



// WEBPACK FOOTER //
// ./src/config/theme/theme.js